var ChildStatusView = require('childstatusview');
var twitch = require('../../lib/twitch.es6');


var ChannelStatusView = ChildStatusView.extend({
    events: $.extend({}, ChildStatusView.prototype.events, {
        'buttonClick button.rejoin': 'clickRejoin',
        'buttonClick button.archive': 'clickArchive',
        'buttonClick button.unarchive': 'clickUnarchive',
        'click': 'mouseTitle',
        'mousemove': 'mouseTitle',
        'mousedown': 'mouseTitle',
        'click .memberToggle': 'clickMemberToggle',
        'buttonClick .memberToggle': 'clickMemberToggle',
        'click .twitchViewers': 'clickTwitchViewers',
        'buttonClick .twitchViewers': 'clickTwitchViewers',
        'buttonClick .twitchRooms': 'clickTwitchRooms',
        'click .twitchStatus': 'clickTwitchStatus'
    }),
    clickMemberToggle: function (e) {
        this.model.setShowMembersPref(!this.model.shouldShowMemberList());
        return false;
    },
    clickTwitchViewers: function (e) {
        this.label.find('a')[0].click();
    },
    clickTwitchStatus: function (e) {
        twitch.popupStream(this.model.session, this.model.normalise());
    },
    clickRejoin: function (e) {
        this.model.join();
        return false;
    },
    clickArchive: function (e) {
        this.model.archive();
        return false;
    },
    clickUnarchive: function (e) {
        this.model.unarchive();
        return false;
    },
    mouseTitle: function (e) {
        switch (e.type) {
        case 'mousedown':
            this.mouseMoving = false;
            break;
        case 'mousemove':
            this.mouseMoving = true;
            break;
        case 'click':
            if (!this.mouseMoving) {
                if ($(e.target).is('a')) {
                    return;
                }
                this.toggleExpandTitle();
            }
            this.mouseMoving = false;
            break;
        }
    },
    render: function () {
        ChildStatusView.prototype.render.apply(this, arguments);
        
        this.collapseTitle();
        this.topic = $('<span class="topic">');
        this.title.append(this.topic);
        
        this.model.bind('urlChange', this.renderLabel, this);
        this.model.bind('modeChange', this.renderLabel, this);
        this.model.bind('change:name', this.renderLabel, this);
        
        this.renderTooltip();
        this.model.bind('timestampChange', this.renderTooltip, this);
        this.model.bind('urlChange', this.renderTooltip, this);

        this.renderTopic();
        this.model.bind('topicChange', function () {
            this.renderTopic();
            if (this.model.isActive()) {
                this.expandTitle();
            }
        }, this);

        this.renderTwitchRooms();
        this.model.bind('twitchChannelChange', this.renderTwitchInfo, this);
        
        this.model.bind('init', function () {
            if (this.model.connection.isInitialized()) {
                this.expandTitle();
            }
        }, this);
        
        return this;
    },
    renderTwitchRoomLabel: function (twitchRoomParts) {
        var roomInfo = twitchRoomParts[0];
        var twitchInfo = twitchRoomParts[1];

        this.renderTwitchLabel(twitchInfo);

        var roomTitle = $('<span class="twitchRoom explanation">').text(' room: ' + roomInfo.name);
        this.label.append(roomTitle);

        if (roomInfo.minimum_allowed_role != 'EVERYONE') {
            var lockTitle = twitch.roomType(roomInfo);
            var lock = $('<i class="fa fa-lock">').attr('title', lockTitle);
            if (this.label.find('img')[0]) {
                this.label.find('img').after(lock);
            } else {
                this.label.prepend(lock);
            }
        }
    },
    renderTwitchLabel: function (twitchInfo) {
        var displayName = this.model.getDisplayName();
        var twitchDisplayName = this.model.getTwitchDisplayName(twitchInfo);
        var title;
        if (twitchDisplayName) {
            title = this.formatter.escapeText(twitchDisplayName);
        } else {
            title = this.formatter.render(displayName);
        }
        if (twitchInfo.channel.url) {
            this.label.html(this.formatter.linker.makeLinkFromBits(title, {
                url: twitchInfo.channel.url,
                target: '_blank'
            }));
        } else {
            this.label.html(title);
        }
        if (twitchDisplayName) {
            if (twitchInfo.channel.name.toLowerCase() != twitchDisplayName.toLowerCase()) {
                this.label.append(' (' + this.formatter.escapeText(twitchInfo.channel.name) + ')');
            }
            if (twitchInfo.viewers) {
                var twitchStatus = $('<span class="twitchStatus">');
                twitchStatus.append('<i class="fa fa-play-circle">');
                this.label.prepend(twitchStatus);
            }
        }
        if (twitchInfo.game) {
            var gameUrl = 'https://www.twitch.tv/directory/game/' + twitchInfo.game;
            var gameLink = $('<a>').attr({
                href: gameUrl,
                target: '_blank'
            }).text(twitchInfo.game);
            this.label.append(' playing ').append(gameLink);
        }
        if (twitchInfo.channel.logo) {
            this.label.prepend($('<img>').attr({
                src: twitchInfo.channel.logo,
                width: 32,
                height: 32
            }).css({
                'vertical-align': 'middle',
                'margin': '0 10px 0 0'
            }));
        }
    },
    renderLabel: function () {
        var twitchInfo = this.model.getTwitchInfo();
        if (twitchInfo) {
            this.renderTwitchLabel(twitchInfo);
        } else {
            var twitchRoomParts = this.model.getTwitchRoomParts();
            if (twitchRoomParts) {
                this.renderTwitchRoomLabel(twitchRoomParts);
            } else {
                var displayName = this.model.getDisplayName();
                var title = this.formatter.render(displayName);
                var label = title;
                var channelUrl = this.model.getUrl();
                if (channelUrl) {
                    var cleanLink = this.formatter.linker.makeLinkFromUrl(channelUrl, title);
                    if (cleanLink) {
                        label = cleanLink;
                    }
                }
                if (this.model.isSlackMultiPersonDm()) {
                    label = 'Direct message with ' + label;
                }
                this.label.html(label);
                var safeChanSuffix = this.model.safeChanSuffix();
                if (safeChanSuffix) {
                    this.label.append(' ').append($('<small>').text(safeChanSuffix));
                }
                if (this.model.isPassworded()) {
                    this.label.prepend('<i class="fa fa-lock" title="Password protected">');
                } else if (this.model.connection.isSlack() && this.model.isSecret()) {
                    this.label.prepend('<i class="fa fa-lock" title="Private channel">');
                }
            }
        }
        this.trigger('topChange');
    },
    renderButtons: function () {
        ChildStatusView.prototype.renderButtons.apply(this);
        
        this.appendButton('rejoin', 'Rejoin');
        this.appendButton('archive', 'Archive');
        this.appendButton('unarchive', 'Unarchive');
        
        this.memberCount = $('<span>');
        this.memberCountWrapper = $('<span class="totalMemberCount" role="button" tabindex="0">')
            .attr({
                'title': 'Members list',
                'aria-label': 'Members list'
            })
            .addClass('memberToggle')
            .append('<i class="fa fa-list-ul">')
            .append('<i class="fa fa-twitch">')
            .append(this.memberCount);
        this.buttons.append(this.memberCountWrapper);

        if (this.model.connection.isTwitch()) {
            var twitchRoomsButton = $('<button class="twitchRooms fa fa-list-alt">');
            this.buttons.append(twitchRoomsButton);
        }

        this.appendOptionsButton();
    },
    clickTwitchRooms: function (e) {
        var twitchInfo = this.model.getTwitchInfo();
        if (twitchInfo && twitchInfo.rooms) {
            this.model.trigger('twitchRoomsOverlay', twitchInfo.rooms);
        }
    },
    renderMemberCount: function () {
        var members, title;
        var twitchInfo = this.model.getTwitchInfo();
        this.memberCountWrapper.toggleClass('memberToggle', !twitchInfo);
        this.memberCountWrapper.toggleClass('twitchViewers', !!twitchInfo);
        if (twitchInfo) {
            if (twitchInfo.viewers) {
                title = 'Watching now';
                members = twitchInfo.viewers;
            } else {
                title = 'Offline';
                members = 'Offline';
            }
        } else {
            if (this.model.chan_members_failed) {
                if (this.model.chan_members_failed === 'timeout') {
                    title = 'The system is overloaded and functionality may be slow or unavailable.';
                } else {
                    title = 'The system is having problems and some functionality may not be working properly.';
                }
                members = 'Unavailable';
            } else {
                title = 'Members list';
                members = this.model.members.length;
            }
        }
        this.memberCountWrapper.attr({
            'title': title,
            'aria-label': title
        });
        this.memberCount.text(members.toLocaleString());
        this.trigger('topChange');
    },
    renderTwitchTopic: function (twitchInfo) {
        this.topic.html(this.formatter.renderLinkify(twitchInfo.channel.status));
        if (twitchInfo.created_at) {
            var time = new Date(twitchInfo.created_at);
            var title = 'Started on ' + time.formatFullDate();
            this.topic.attr("title", title);
        } else {
            this.topic.removeAttr('title');
        }
    },
    renderTwitchRoomTopic: function (twitchRoomParts) {
        var roomInfo = twitchRoomParts[0];
        var twitchInfo = twitchRoomParts[1];
        this.topic.html(this.formatter.renderLinkify(roomInfo.topic));
    },
    renderTwitchRooms: function () {
        this.$el.toggleClass('hasTwitchRooms', this.model.hasTwitchRooms());
    },
    renderTopic: function () {
        var twitchInfo = this.model.getTwitchInfo();
        if (twitchInfo && twitchInfo.channel.status) {
            this.renderTwitchTopic(twitchInfo);
        } else {
            var twitchRoomParts = this.model.getTwitchRoomParts();
            if (twitchRoomParts) {
                this.renderTwitchRoomTopic(twitchRoomParts);
            } else {
                if (this.model.topic) {
                    this.topic.html(this.formatter.renderLinkifyComicSans(this.model.topic.get('topic')));
                    var author = this.model.topic.get('author');
                    var server = this.model.topic.get('server');
                    if (author || server) {
                        var title = 'Topic set';
                        if (server) {
                            title += ' by the server ' + server;
                        } else {
                            var authorTitle = author.getTitleWithHostmask();
                            if (authorTitle) {
                                title += ' by ' + authorTitle;
                            }
                        }
                        var time = this.model.topic.getTime();
                        if (time) {
                            title += ' on ' + time.formatFullDate();
                        }
                        this.topic.attr("title", title);
                    } else {
                        this.topic.removeAttr('title');
                    }
                } else {
                    this.topic.empty();
                    this.topic.removeAttr('title');
                }
            }
        }
        this.trigger('topChange');
    },
    renderTooltip: function () {
        var url = this.model.getUrl();
        if (this.model.timestamp > 0 || url) {
            var title = '';
            if (this.model.timestamp > 0) {
                title += "Created on " + this.model.getTimestamp().formatFullDate() + ' ';
            }
            if (url) {
                title += '(' + url + ')';
            }
            this.title.attr('title', title);
        } else {
            this.title.removeAttr('title');
        }
    },
    renderTwitchInfo: function () {
        this.renderLabel();
        this.renderTopic();
        this.renderMemberCount();
        this.renderTwitchRooms();
    }
});


module.exports = ChannelStatusView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/channelstatusview.js
// module id = Fj2Y
// module chunks = 1